import {CSSProperties} from '../../../styleSheet';
import assert from 'assert-ts';
import {ThemeDeviceNames} from '../../../theme/types/ThemeDevices';
import {ResponsiveStyle} from '../types';

export const getResponsiveBaseStylePrDeviceClass = (
  deviceStyles: ResponsiveStyle,
  deviceRanges: ThemeDeviceNames,
): CSSProperties | undefined => {
  const retVal: {[key: string]: CSSProperties} = {};

  // Loop through ranges and create media queries
  Object.keys(deviceStyles).forEach(deviceName => {
    let expression = '@media screen ';
    const range = deviceRanges[deviceName as keyof ThemeDeviceNames];

    if (range.max !== undefined) {
      expression += ` and (max-width:${range.max}px)`;
    }
    if (range.min !== undefined) {
      expression += ` and (min-width:${range.min}px)`;
    }

    retVal[expression] = assert(
      deviceStyles[deviceName as keyof ThemeDeviceNames],
    );
  });

  return retVal;
};
